






























import { Vue, Component } from "vue-property-decorator";
import { db, busy, VIPIpRest, DEBUG } from "@/loader";
import { BvModalEvent } from "bootstrap-vue";
import IpSelect from "./IpSelect.vue";

@Component({
	components: {
		IpSelect
	}
})
export default class IpNewModal extends Vue {
	public newCode: number = 0;
	public error: string = "";
	public parent: number = 0;

	public checkCode(v?: number): boolean {
		DEBUG && console.log(`checking code ${this.newCode}, value is ${v}`);
		if (!this.newCode) {
			this.error = "Le code ne peut pas être vide";
			return false;
		} else if (Number.isNaN(this.newCode)) {
			this.error = "Le code doit être un nombre valide";
			return false;
		} else if (db.ips.list.find(ip => ip.code === this.newCode)) {
			this.error = `Le code ${this.newCode} est déjà utilisé`;
			return false;
		}

		this.error = "";
		return true;
	}

	public selectParent(ip: VIPIp | null) {
		this.parent = ip?.id || 0;
	}

	public createIP(event: BvModalEvent) {
		if (!this.checkCode() || !event?.preventDefault) {
			return;
		}

		busy.start(`Création de l'IP ${this.newCode} ...`);
		VIPIpRest.create({ code: this.newCode, fk_parent: this.parent, name: "Nouvelle IP" }).then(result => {
			if (result.success) {
				this.parent = 0;
				this.newCode = 0;
				this.$emit("created", result.item);
			} else {
				this.error = result.error?.message;
				event.preventDefault();
			}
		}).finally(() => {
			busy.stop();
		});
	}
}
